import type { Content } from '@/types/content';
import type { ItineraryBlock } from '@/types/itinerary';

export function getMainContentItineraryBlock(itineraryProduct: ItineraryBlock) {
  return itineraryProduct?.Content?.filter((content: Content) => content.type.toLowerCase() === 'main')[0];
}
